import { OnboardingSubItemKey } from '@pages/common/Onboarding/enum/onboarding-sub-item-key';
import { ByTransactionCategoryEnum } from '@pages/organizer/Finance/components/tabs/PaymentHistory/enum/selectOption/by-transaction-category-enum';
import { CalendarRoutesPathEnum } from '@setup/router/routes/calendar/calendarRoutesPath.enum';
import { ChecklistsRoutesPathEnum } from '@setup/router/routes/checklists/checklistsRoutesPath.enum';
import { EducationRoutesPathEnum } from '@setup/router/routes/education/educationRoutesPath.enum';
import { FinanceRoutesPathEnum } from '@setup/router/routes/finance/financeRoutesPath.enum';
import { GarageRoutesPathEnum } from '@setup/router/routes/garage/garageRoutesPath.enum';
import { NetworkRoutesPathEnum } from '@setup/router/routes/network/networkRoutesPath.enum';
import { NotesRoutesPathEnum } from '@setup/router/routes/notes/notesRoutesPath.enum';
import { PetsRoutesPathEnum } from '@setup/router/routes/pets/petsRoutesPath.enum';
import { ProfileRoutesPathEnum } from '@setup/router/routes/profile/profileRoutesPath.enum';
import { PropertyRoutesPathEnum } from '@setup/router/routes/property/propertyRoutesPath.enum';
import { SettingsRoutesPathEnum } from '@setup/router/routes/settings/settingsRoutesPath.enum';
import { WorkRoutesPathEnum } from '@setup/router/routes/work/workRoutesPath.enum';
import { AnalyticsEventEnum } from '@shared/enums/analyticsEvent.enum';
import { ModalNamesEnum } from '@shared/enums/modalNames.enum';
import { PaymentItemTypeEnum } from '@shared/enums/organizer/paymentItemType.enum';
import { TagsEnum } from '@shared/enums/tags.enum';
import modalObserver from '@shared/utils/observers/modalObserver';

const handleCloseOnboardingSetupModal = () => {
  return true;
};

export const redirectLinkByKey: {
  [Key in OnboardingSubItemKey]: {
    to: string;
    click: () => void;
    analyticsKey?: AnalyticsEventEnum;
  };
} = {
  [OnboardingSubItemKey.bank_account]: {
    to: `${FinanceRoutesPathEnum.finance}/${FinanceRoutesPathEnum.wallet}`,
    click: () => true,
    analyticsKey: AnalyticsEventEnum.onboardingChecklistFinanceSelected,
  },
  [OnboardingSubItemKey.credit_score]: {
    to: `${FinanceRoutesPathEnum.finance}/${FinanceRoutesPathEnum.creditHistory}`,
    click: () => true,
    analyticsKey: AnalyticsEventEnum.onboardingChecklistCreditScoreSelected,
  },
  [OnboardingSubItemKey.first_contact]: {
    to: `${NetworkRoutesPathEnum.network}`,
    click: () => {
      modalObserver.addModal(ModalNamesEnum.invitationModal, {});
    },
    analyticsKey: AnalyticsEventEnum.onboardingChecklistInviteToHubmeeSelected,
  },
  [OnboardingSubItemKey.google_sync]: {
    to: `${SettingsRoutesPathEnum.settings}`,
    click: () => true,
    analyticsKey: AnalyticsEventEnum.onboardingChecklistGoogleSyncSelected,
  },
  [OnboardingSubItemKey.property_hub]: {
    to: `${PropertyRoutesPathEnum.property}/${PropertyRoutesPathEnum.createNewProperty}`,
    click: () => {
      handleCloseOnboardingSetupModal();
    },
  },
  [OnboardingSubItemKey.utility_payment]: {
    to: `${FinanceRoutesPathEnum.finance}/${FinanceRoutesPathEnum.paymentHistory}?isCreate=1`,
    click: () => {
      modalObserver.addModal(ModalNamesEnum.createTransaction, {
        props: {
          payment_type: PaymentItemTypeEnum.expense,
          hub: TagsEnum.property,
        },
      });
      handleCloseOnboardingSetupModal();
    },
  },

  [OnboardingSubItemKey.work_hub]: {
    to: `${WorkRoutesPathEnum.work}/${WorkRoutesPathEnum.createNewWork}`,
    click: () => {
      handleCloseOnboardingSetupModal();
    },
  },
  [OnboardingSubItemKey.work_meeting]: {
    to: `${CalendarRoutesPathEnum.calendar}`,
    click: () => {
      modalObserver.addModal(ModalNamesEnum.createMeetingModal, {
        props: {},
      });
      handleCloseOnboardingSetupModal();
    },
  },

  [OnboardingSubItemKey.education_hub]: {
    to: `${EducationRoutesPathEnum.education}/${EducationRoutesPathEnum.createNewEducation}`,
    click: () => {
      handleCloseOnboardingSetupModal();
    },
  },
  [OnboardingSubItemKey.education_note]: {
    to: `${NotesRoutesPathEnum.notes}`,
    click: () => {
      handleCloseOnboardingSetupModal();
    },
  },

  [OnboardingSubItemKey.vet_appointment]: {
    to: `${CalendarRoutesPathEnum.calendar}`,
    click: () => {
      modalObserver.addModal(ModalNamesEnum.createAppointmentModal, {
        props: {},
      });
      handleCloseOnboardingSetupModal();
    },
  },
  [OnboardingSubItemKey.pets_hub]: {
    to: `${PetsRoutesPathEnum.pets}/${PetsRoutesPathEnum.createNewPet}`,
    click: () => {
      handleCloseOnboardingSetupModal();
    },
  },

  [OnboardingSubItemKey.schedule_event]: {
    to: `${CalendarRoutesPathEnum.calendar}`,
    click: () => {
      modalObserver.addModal(ModalNamesEnum.createEventModal, {
        props: {},
      });
      handleCloseOnboardingSetupModal();
    },
  },
  [OnboardingSubItemKey.create_task]: {
    to: `${CalendarRoutesPathEnum.calendar}`,
    click: () => {
      modalObserver.addModal(ModalNamesEnum.createTaskModal, {
        props: {},
      });
      handleCloseOnboardingSetupModal();
    },
  },

  [OnboardingSubItemKey.garage_hub]: {
    to: `${GarageRoutesPathEnum.garage}/${GarageRoutesPathEnum.createNewCar}`,
    click: () => {
      handleCloseOnboardingSetupModal();
    },
  },
  [OnboardingSubItemKey.vehicle_payment]: {
    to: `${FinanceRoutesPathEnum.finance}/${FinanceRoutesPathEnum.paymentHistory}?isCreate=1`,
    click: () => {
      modalObserver.addModal(ModalNamesEnum.createTransaction, {
        props: {
          payment_type: PaymentItemTypeEnum.expense,
          hub: TagsEnum.garage,
        },
      });
      handleCloseOnboardingSetupModal();
    },
  },

  [OnboardingSubItemKey.activity_hobby]: {
    to: `${CalendarRoutesPathEnum.calendar}`,
    click: () => {
      modalObserver.addModal(ModalNamesEnum.createReminderModal, {
        props: {},
      });
      handleCloseOnboardingSetupModal();
    },
  },
  [OnboardingSubItemKey.personal_hub]: {
    to: `${ProfileRoutesPathEnum.base}`,
    click: () => {
      handleCloseOnboardingSetupModal();
    },
  },

  [OnboardingSubItemKey.payment]: {
    to: `${FinanceRoutesPathEnum.finance}/${FinanceRoutesPathEnum.paymentHistory}?isCreate=1`,
    click: () => {
      modalObserver.addModal(ModalNamesEnum.createTransaction, {
        props: {
          payment_type: PaymentItemTypeEnum.expense,
          category: ByTransactionCategoryEnum.bills_utilities,
        },
      });
      handleCloseOnboardingSetupModal();
    },
  },
  [OnboardingSubItemKey.add_checklist]: {
    to: `${ChecklistsRoutesPathEnum.checklists}`,
    click: () => {
      handleCloseOnboardingSetupModal();
    },
  },
};
